// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.MuiBox-root{*/
/*    !*height: 90% !important;*!*/
/*    !*width: auto !important;*!*/
/*}*/
/*.link{*/
/*    text-decoration: underline;*/
/*    color: rgb(0, 106, 198);*/
/*    cursor: pointer;*/
/*}*/

/*.CardBoxV2 img{*/
/*    margin-bottom: 20px;*/
/*    max-height: 55px;*/
/*}*/

.css-7ldjcq-MuiGrid-root>.MuiGrid-item{
    padding-left: 0 !important;
}

.css-7ldjcq-MuiGrid-root{
   margin-left: 0 !important;
}

/*.CardBoxV3{*/
/*    margin-right: 30px;*/
/*    padding-right: 30px;*/
/*    max-height: 35px;*/
/*}*/

/*.divCardContainer{*/
/*    gap: 14px*/
/*}*/

/*.divUploadLogoSponsor{*/
/*    right: 137px !important;*/
/*    top: 194px !important;*/
/*}*/

/*.divNameLogoSponsor{*/
/*    right: 300px !important;*/
/*}*/

/*.wrapperCardAddNewList{*/
/*    width: 190px;*/
/*}*/`, "",{"version":3,"sources":["webpack://./src/adminCore/sponsor/style.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,kCAAkC;AAClC,kCAAkC;AAClC,IAAI;AACJ,SAAS;AACT,kCAAkC;AAClC,+BAA+B;AAC/B,uBAAuB;AACvB,IAAI;;AAEJ,kBAAkB;AAClB,2BAA2B;AAC3B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,0BAA0B;AAC9B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA,cAAc;AACd,0BAA0B;AAC1B,2BAA2B;AAC3B,wBAAwB;AACxB,IAAI;;AAEJ,qBAAqB;AACrB,gBAAgB;AAChB,IAAI;;AAEJ,yBAAyB;AACzB,+BAA+B;AAC/B,6BAA6B;AAC7B,IAAI;;AAEJ,uBAAuB;AACvB,+BAA+B;AAC/B,IAAI;;AAEJ,0BAA0B;AAC1B,oBAAoB;AACpB,IAAI","sourcesContent":["/*.MuiBox-root{*/\r\n/*    !*height: 90% !important;*!*/\r\n/*    !*width: auto !important;*!*/\r\n/*}*/\r\n/*.link{*/\r\n/*    text-decoration: underline;*/\r\n/*    color: rgb(0, 106, 198);*/\r\n/*    cursor: pointer;*/\r\n/*}*/\r\n\r\n/*.CardBoxV2 img{*/\r\n/*    margin-bottom: 20px;*/\r\n/*    max-height: 55px;*/\r\n/*}*/\r\n\r\n.css-7ldjcq-MuiGrid-root>.MuiGrid-item{\r\n    padding-left: 0 !important;\r\n}\r\n\r\n.css-7ldjcq-MuiGrid-root{\r\n   margin-left: 0 !important;\r\n}\r\n\r\n/*.CardBoxV3{*/\r\n/*    margin-right: 30px;*/\r\n/*    padding-right: 30px;*/\r\n/*    max-height: 35px;*/\r\n/*}*/\r\n\r\n/*.divCardContainer{*/\r\n/*    gap: 14px*/\r\n/*}*/\r\n\r\n/*.divUploadLogoSponsor{*/\r\n/*    right: 137px !important;*/\r\n/*    top: 194px !important;*/\r\n/*}*/\r\n\r\n/*.divNameLogoSponsor{*/\r\n/*    right: 300px !important;*/\r\n/*}*/\r\n\r\n/*.wrapperCardAddNewList{*/\r\n/*    width: 190px;*/\r\n/*}*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
